<template>
  <div id="classify" :style="{backgroundImage: `url(${imgBg})` }">
    <div class="page-box" >
      <com-header ref="header"/>
      <div class="page-box-list-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
        <div class="search-content ">
          <com-card :imgList="imgList" :total="imgRequest.total" v-if="imgList.length > 0" @collectCall="collectCall"/>
        </div>
      </div>
    </div>
    <el-backtop target=".page-box-list-scroll"></el-backtop>

  </div>
</template>

<script>
export default {
  name: "imgDetails",
  data(){
    return {
      imgRequest: {
        size: 9,
        page: 1,
        three_phototag_id: '',
        total: '',
        imgBg:''
      },
      imgList:[],
      imgBg:'',
      loading: true
    }
  },
  mounted(){
    this.imgRequest.three_phototag_id = this.$route.query.id
    this.getCLassList()
    this.getImgBg({id: this.$route.query.id })
  },
  methods:{
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    load() {
      if (this.imgRequest.total > this.imgList.length && this.loading) {
        this.loading = false
        this.imgRequest.page = this.imgRequest.page + 1
        this.getCLassList()
      }
    },
    getCLassList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
      this.$get('/pc/shop/threeClassifyPhotoPackage', this.imgRequest).then((res) => {
        loading.close();
        this.loading = true
        this.imgList = [...this.imgList, ...res.data]
        this.imgRequest.total = res.meta.total
      }).catch((error) => {
        loading.close();
        this.loading = true
      })
    },
    collectCall(data) {
      this.$refs.header.getCollect()
      this.imgList.forEach((item) => {
        if (item.id === data.id) {
          if (item.iscollect === 0) {
            item.iscollect = 1
            item.collection = Number(item.collection) + 1
          } else {
            item.iscollect = 0
            item.collection = Number(item.collection) - 1
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.page-box {
  height: 100vh;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/imgDetails.vue